import {
  PDF_TEMPLATE_LIST,
  PDF_TEMPLATE_LIST_SUCCESS,
  PDF_TEMPLATE_LIST_FAILURE,
  PDF_TEMPLATE_RENDER,
  PDF_TEMPLATE_RENDER_SUCCESS,
  PDF_TEMPLATE_RENDER_FAILURE,
  PDF_TEMPLATE_SAVE,
  PDF_TEMPLATE_SAVE_SUCCESS,
  PDF_TEMPLATE_SAVE_FAILURE,
  PDF_TEMPLATE_DELETE,
  PDF_TEMPLATE_DELETE_SUCCESS,
  PDF_TEMPLATE_DELETE_FAILURE,
  PDF_TEMPLATE_DUPLICATE,
  PDF_TEMPLATE_DUPLICATE_SUCCESS,
  PDF_TEMPLATE_DUPLICATE_FAILURE,
  PDF_TEMPLATE_UPLOAD_SOURCE,
  PDF_TEMPLATE_UPLOAD_SOURCE_SUCCESS,
  PDF_TEMPLATE_UPLOAD_SOURCE_FAILURE,
  PDF_TEMPLATE_PREVIEW,
  PDF_TEMPLATE_PREVIEW_SUCCESS,
  PDF_TEMPLATE_PREVIEW_FAILURE,
} from "./actionType";

const initialValue = {
  pdfTemplateList: [],
  pdfTemplateListLoading: false,
  pdfTemplateListError: null,

  pdfTemplateRender: [],
  pdfTemplateRenderLoading: false,
  pdfTemplateRenderError: null,

  pdfTemplateSave: [],
  pdfTemplateSaveLoading: false,
  pdfTemplateSaveError: null,

  pdfTemplateDelete: [],
  pdfTemplateDeleteLoading: false,
  pdfTemplateDeleteError: null,

  pdfTemplateDuplicate: [],
  pdfTemplateDuplicateLoading: false,
  pdfTemplateDuplicateError: null,

  pdfTemplateUploadSource: [],
  pdfTemplateUploadSourceLoading: false,
  pdfTemplateUploadSourceError: null,

  pdfTemplatePreview: [],
  pdfTemplatePreviewLoading: false,
  pdfTemplatePreviewError: null,
};

const PdfTemplate = (state = initialValue, action) => {
  switch (action.type) {
    // List
    case PDF_TEMPLATE_LIST:
      return {
        ...state,
        pdfTemplateListLoading: true,
        pdfTemplateListError: null,
      };
    case PDF_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        pdfTemplateList: action.payload,
        pdfTemplateListLoading: false,
      };
    case PDF_TEMPLATE_LIST_FAILURE:
      return {
        ...state,
        pdfTemplateListLoading: false,
        pdfTemplateListError: action.payload,
      };

    // Render (designer bundle)
    case PDF_TEMPLATE_RENDER:
      return {
        ...state,
        pdfTemplateRenderLoading: true,
        pdfTemplateRenderError: null,
      };
    case PDF_TEMPLATE_RENDER_SUCCESS:
      return {
        ...state,
        pdfTemplateRender: action.payload,
        pdfTemplateRenderLoading: false,
      };
    case PDF_TEMPLATE_RENDER_FAILURE:
      return {
        ...state,
        pdfTemplateRenderLoading: false,
        pdfTemplateRenderError: action.payload,
      };

    // Save
    case PDF_TEMPLATE_SAVE:
      return {
        ...state,
        pdfTemplateSaveLoading: true,
        pdfTemplateSaveError: null,
      };
    case PDF_TEMPLATE_SAVE_SUCCESS:
      return {
        ...state,
        pdfTemplateSave: action.payload,
        pdfTemplateSaveLoading: false,
      };
    case PDF_TEMPLATE_SAVE_FAILURE:
      return {
        ...state,
        pdfTemplateSaveLoading: false,
        pdfTemplateSaveError: action.payload,
      };

    // Delete
    case PDF_TEMPLATE_DELETE:
      return {
        ...state,
        pdfTemplateDeleteLoading: true,
        pdfTemplateDeleteError: null,
      };
    case PDF_TEMPLATE_DELETE_SUCCESS:
      return {
        ...state,
        pdfTemplateDelete: action.payload,
        pdfTemplateDeleteLoading: false,
      };
    case PDF_TEMPLATE_DELETE_FAILURE:
      return {
        ...state,
        pdfTemplateDeleteLoading: false,
        pdfTemplateDeleteError: action.payload,
      };

    // Duplicate
    case PDF_TEMPLATE_DUPLICATE:
      return {
        ...state,
        pdfTemplateDuplicateLoading: true,
        pdfTemplateDuplicateError: null,
      };
    case PDF_TEMPLATE_DUPLICATE_SUCCESS:
      return {
        ...state,
        pdfTemplateDuplicate: action.payload,
        pdfTemplateDuplicateLoading: false,
      };
    case PDF_TEMPLATE_DUPLICATE_FAILURE:
      return {
        ...state,
        pdfTemplateDuplicateLoading: false,
        pdfTemplateDuplicateError: action.payload,
      };

    // Upload source PDF
    case PDF_TEMPLATE_UPLOAD_SOURCE:
      return {
        ...state,
        pdfTemplateUploadSourceLoading: true,
        pdfTemplateUploadSourceError: null,
      };
    case PDF_TEMPLATE_UPLOAD_SOURCE_SUCCESS:
      return {
        ...state,
        pdfTemplateUploadSource: action.payload,
        pdfTemplateUploadSourceLoading: false,
      };
    case PDF_TEMPLATE_UPLOAD_SOURCE_FAILURE:
      return {
        ...state,
        pdfTemplateUploadSourceLoading: false,
        pdfTemplateUploadSourceError: action.payload,
      };

    // Preview
    case PDF_TEMPLATE_PREVIEW:
      return {
        ...state,
        pdfTemplatePreviewLoading: true,
        pdfTemplatePreviewError: null,
      };
    case PDF_TEMPLATE_PREVIEW_SUCCESS:
      return {
        ...state,
        pdfTemplatePreview: action.payload,
        pdfTemplatePreviewLoading: false,
      };
    case PDF_TEMPLATE_PREVIEW_FAILURE:
      return {
        ...state,
        pdfTemplatePreviewLoading: false,
        pdfTemplatePreviewError: action.payload,
      };

    default:
      return state;
  }
};

export default PdfTemplate;
